export const MAX_TOTAL_SIZE_TICKET_REPLY_MB = 5;
export const MAX_TOTAL_SIZE_TICKET_REPLY_BYTES =
  MAX_TOTAL_SIZE_TICKET_REPLY_MB * 1024 * 1024;
